module.exports = __webpack_public_path__ + "fonts/Gilroy-LightItalic.0cf6584c.woff";